import { render, staticRenderFns } from "./OrderRequestReview.vue?vue&type=template&id=19812de6"
import script from "./OrderRequestReview.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderRequestReview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports